export default __webpack_public_path__ + "static/media/fassaden-backgrpund.77047d04.jpg";